import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { HubReplenishing, HubRetrieve, KioskSubReplenishing, KioskSubRestocking, KioskSubRetrieve, LearningModule, OrderManagementModule, ScanTraining, SmartShelvesSubReplenishing, SmartShelvesSubRestocking, SmartShelvesSubRetrieve, TrainingModule } from '../../models';
import { actionCreators, State } from '../../state';
import { trainingForModule } from '../LearninHome/LearninHome';
import './SubModuleCard.css';
import Modal from '../../pages/Modal/Modal';
import { createPortal } from 'react-dom';

interface SubModuleCardProps {
  subModule: LearningModule
  index: number
}

enum ReplenishOptions {
  ReplenishmentScanner = 1,
  SmartShelfScanner = 2,
  NotSelected = 3
}

const SubModuleCard: FC<SubModuleCardProps> = ({subModule, index}:SubModuleCardProps) => {
  
  const [showReplenishOptions, setShowReplenishOptions] = useState<boolean>(false)
  let replenishOptionSelected = ReplenishOptions.NotSelected

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { navState } = useSelector((state: State) => state)
  const { updateNavState, updateTrainingState } = bindActionCreators(actionCreators, dispatch)

  const trainingInfoForSubModule = (subModule: LearningModule): {training: TrainingModule, subModuleIndex: number} => {
    switch (subModule) {
      case KioskSubRetrieve:
        return {training: TrainingModule.Kiosk, subModuleIndex: 0}
      case KioskSubRestocking:
        return {training: TrainingModule.Kiosk, subModuleIndex: 1}
      case KioskSubReplenishing:
        return {training: TrainingModule.Kiosk, subModuleIndex: 2}
      case HubRetrieve:
        return {training: TrainingModule.Hub, subModuleIndex: 0}
      case HubReplenishing:
        return {training: TrainingModule.Hub, subModuleIndex: 1}
      case SmartShelvesSubRetrieve:
        return {training: TrainingModule.SmartShelves, subModuleIndex: 0}
      case SmartShelvesSubRestocking:
        return {training: TrainingModule.SmartShelves, subModuleIndex: 1}
      case SmartShelvesSubReplenishing:
        if (replenishOptionSelected === ReplenishOptions.ReplenishmentScanner) {
          return {training: TrainingModule.SmartShelves, subModuleIndex: 2}  
        }
        return {training: TrainingModule.SmartShelves, subModuleIndex: -1}
      case ScanTraining:
        return {training: TrainingModule.ScanningSutures, subModuleIndex: 0}
      case OrderManagementModule:
        return {training: TrainingModule.OrderManagement, subModuleIndex: 0}
      default:
        return {training: TrainingModule.Kiosk, subModuleIndex: 0}
    }
  }

  const selectedModule = () => {
    if (subModule === SmartShelvesSubReplenishing && replenishOptionSelected === ReplenishOptions.NotSelected) {
      setShowReplenishOptions(true)
      return
    }
    var ns = navState.stack
    const trainingInfo = trainingInfoForSubModule(subModule)
    const path = '/module'
    ns.push({
      subModuleIndex: trainingInfo.subModuleIndex,
      trainingModule: trainingInfo.training,
      path: path
    })
    updateNavState({stack: ns})
    var training = trainingForModule(trainingInfo.training)
    if (training) {
      training.currentTraining.currentSubModuleIndex = trainingInfo.subModuleIndex
      training.currentTraining.currentStepIndex = 0
      updateTrainingState(training)
      navigate(path)
    }
  }

  const replenishModal = () => {
    return (
      <Modal 
        message='How would you like to replenish Sutures in the Smart Shelf?'
        primaryActionButtonInfo={{
          text: 'Replenishment Scanner', 
          color: 'var(--crimson)',
          action: () => {
            setTimeout(() => {
              selectedModule()
            }, 750)
            replenishOptionSelected = ReplenishOptions.ReplenishmentScanner
            setShowReplenishOptions(false)
          }
        }}
        additonalActionButtonInfos={[
          {
            text: 'Smart Shelf Scanner',
            color: 'var(--crimson)',
            action: () => {
              setTimeout(() => {
                selectedModule()
              }, 750)
              replenishOptionSelected = ReplenishOptions.SmartShelfScanner
              setShowReplenishOptions(false)
            }
          }
        ]}
        onClose={() => {
          replenishOptionSelected = ReplenishOptions.NotSelected
          setShowReplenishOptions(false)
        }}
        allowBackgroundClose={true}
      />
    )
  }

  return (
    <div className="SubModuleCard" onClick={selectedModule} style={{width: `${subModule.cardWidth}px`}}>
      {subModule.description.split(/(\s+)/)[0]}<span>{` ${subModule.description.split(/(\s+)/).splice(2).join('')}`}</span>
      {showReplenishOptions && 
        createPortal(
          replenishModal(),
          document.body
        )
      }
    </div>
  )
};

export default SubModuleCard;
